<template>
  <div>
    <Header>
    </Header>

    <div class="page">

        <div class="block">
            <a @click="goBack()">&larr; Back to all messages</a>
            <a style="float: right" @click="goDelete()">Delete Message</a>

            <div v-if="contactform">
                  <br>
                        <span class="ellipsis grey">
                        Sent on {{contactform.created | date }}</span>

                  <br>
                        <h3>Name: {{contactform.name}}</h3>
                        <h3>Email: {{contactform.email}}</h3>

                        <br>
                        <strong>Warning: anybody can send you a message through this contact form. They may not be who they claim to be. Journo Portfolio will never contact you about your subscription, domain or payments through your contact form.</strong>
                        <br><br>
                        {{contactform.message}}

            </div>
        </div>

    </div>

</div>
</template>

<script>
    import Header from '@/components/Header.vue'

    export default {
      components: {
        Header,
    },
    data () {
        return {
            contactform: null
        }
    },
    methods: {
      goBack () {
        this.$router.push({ name: 'contactforms'})
      },
      goDelete () {
        this.$http.delete('/contact-forms/'+this.$route.params.id+'/').then(data => {
            this.goBack()
            this.contactform = data.data
        })
      },
    },
    mounted () {
        this.$http.get('/contact-forms/'+this.$route.params.id+'/').then(data => {
            this.contactform = data.data
        })
    }
}
</script>
